import React from "react";
import LoaderForSearch from "../Common/LoaderForSearch";

function HierarchyTable(props) {
  const { checkResp, handleScroll, scrollLoader, isRmYesNo } = props;

  return (
    <>
      <div className="table-responsive scroll-table report-table-wrapper hierarchy-wrapper">
        <table className="table last-column">
          <thead>
            <tr>
              <th scope="col" className="text-center">
                {isRmYesNo === "No" ? "Franchisee Code" : "RM Code"}
              </th>
              <th scope="col" className="text-center">
                {isRmYesNo === "No" ? "Franchisee Name" : "RM Name"}
              </th>
              {isRmYesNo === "No" && (
                <th scope="col" className="text-center">
                  SubBroker
                </th>
              )}

              <th scope="col" className="text-center">
                Total Newly Acquired clients
              </th>
              <th scope="col" className="text-center">
                Traded Clients
              </th>
              <th scope="col" className="text-center">
                Not Traded Clients
              </th>
              <th scope="col" className="text-center">
                Previous Count
              </th>
              <th scope="col" className="text-center">
                Absolute Change
              </th>
              <th scope="col" className="text-center">
                Revenue
              </th>
            </tr>
          </thead>
          <tbody onScroll={(e) => handleScroll(e)}>
            {checkResp &&
              checkResp.map((item, key) => {
                return (
                  <tr key={key}>
                    <td>{item?.EmpCode || "-"}</td>
                    <td>{item?.name || "-"}</td>
                    {isRmYesNo === "No" && <td>{item?.subBroker || "-"}</td>}
                    <td>{item?.totalNewlyAcquiredClients || 0}</td>
                    <td>{item?.tradedClients || 0}</td>
                    <td>{item?.nonTradedClients || 0}</td>
                    <td>{item?.previousCount || 0}</td>
                    <td>{item?.absoluteChange || 0}</td>
                    <td>{item?.revenue || 0}</td>
                  </tr>
                );
              })}
            {scrollLoader && (
              <div className="loader-center">
                <LoaderForSearch />
              </div>
            )}
          </tbody>
        </table>
      </div>
    </>
  );
}
export default HierarchyTable;
